import { SubHeading } from 'components/Typography/General';
import styled from 'styled-components';
import { getDirectionByLanguage } from 'utils/get_direction';
import { getClassNameByLang } from 'utils/getClassByLang';

const TestimonialSection = (props) => {
  const {
    courseTestimoni,
    customerActive,
    totalShowedTestimony,
    lastIndexShownTesti,
    setCustomerActive,
    setLastIndexShownTesti,
    language,
  } = props;

  const classNameByLang = getClassNameByLang(language);

  return (
    <div className="customer-wrapper">
      {courseTestimoni && courseTestimoni.length > 0 ? (
        <>
          <SubHeading variety={3}>Testimonials</SubHeading>
          <CustomerTestimonial>
            <TestimonialQuote>“</TestimonialQuote>
            <TestimonialText dir={getDirectionByLanguage(language)} className={`${classNameByLang}`}>
              {courseTestimoni.filter((item) => item._id === customerActive)[0]?.review}
            </TestimonialText>
          </CustomerTestimonial>
        </>
      ) : (
        ''
      )}
      <div
        className={`customer-avatar-wrapper ${
          courseTestimoni && courseTestimoni.length < totalShowedTestimony ? 'justify-content-start' : ''
        }`}
      >
        {/* do not show the chevron left if testimony length in not more than 5 or if last index of shown testimony === 5*/}
        {courseTestimoni &&
        courseTestimoni.length > totalShowedTestimony &&
        lastIndexShownTesti !== totalShowedTestimony ? (
          <div className="customer-chevron left" onClick={() => setLastIndexShownTesti(lastIndexShownTesti - 1)}>
            <img src={'/prev.svg'} alt="chevron left" />
          </div>
        ) : null}
        {/* do not show the chevron right if testimoni length in not more than 5 or if last index of showed testimoni === testimoni index*/}
        {courseTestimoni &&
        courseTestimoni.length > totalShowedTestimony &&
        lastIndexShownTesti !== courseTestimoni.length ? (
          <div className="customer-chevron right" onClick={() => setLastIndexShownTesti(lastIndexShownTesti + 1)}>
            <img src={'/next.svg'} alt="chevron right" />
          </div>
        ) : null}
        {/* only showing 5 item of testimonial which the lowest index is last index of showed testi - 5 */}
        {courseTestimoni && courseTestimoni.length > 0
          ? courseTestimoni.slice(lastIndexShownTesti - totalShowedTestimony, lastIndexShownTesti).map((row, index) => {
              // avatar is active if id of testimony === active customer that saved in state
              const active = row._id === customerActive;
              return (
                <div
                  key={`testimoni-${index + 1}`}
                  className={`customer ${
                    courseTestimoni && courseTestimoni.length < totalShowedTestimony ? 'me-5' : ''
                  }`}
                  onClick={() => setCustomerActive(row._id)}
                >
                  {/* if the avatar is active, show the active indicator */}
                  <CustomerAvatarWrapper active={active}>
                    <CustomerAvatar src={row.fileImage ? row.fileImage : '/avatar_dummy.svg'} />
                  </CustomerAvatarWrapper>
                  {/* if the avatar is active, show the detail (name and organization name) */}
                  {active ? (
                    <div className={`details ${classNameByLang}`}>
                      <div className="bold">{row.reviewer}</div>
                      <div className="light">{row.organizationName}</div>
                    </div>
                  ) : null}
                </div>
              );
            })
          : ''}
      </div>
    </div>
  );
};

export default TestimonialSection;

// Customer Testimonial
const CustomerTestimonial = styled.div`
  display: flex;
  gap: 1rem;
  position: relative;
  min-height: 23.2rem;
  width: 100%;

  margin-top: 3.2rem;
  // margin-bottom: 3.6rem;

  box-shadow: 0px 3rem 4rem 0 rgba(173, 173, 173, 0.2);
  background-color: white;
  border-radius: 1rem;
  padding: 4.6rem 1.6rem 3.4rem 4.4rem;
`;
const TestimonialQuote = styled.div`
  font-weight: 800;
  font-size: 7.2rem;
  color: rgba(6, 107, 251, 1);
`;

const TestimonialText = styled.div`
  font-size: 1.8rem;
  font-weight: 400;
  color: var(--color-primary-blue-dark);
  padding-top: 2.4rem;
  line-height: 3.2rem;
`;

const CustomerAvatarWrapper = styled.div`
  height: 100%;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    display: ${({ active }) => (active ? 'block' : 'none')};
    left: 0;
    border-width: 1.5rem;
    border-style: solid;
    border-color: white transparent transparent transparent;
  }
`;

// Customer Avatar
const CustomerAvatar = styled.div`
  background-image: url(${({ src }) => src});
  background-position: center;
  background-size: cover;
  height: 5.6rem;
  width: 5.6rem;
  border-radius: 50%;
  position: relative;
  margin-top: 3.6rem;
`;
